"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useIsMobile = void 0;
const react_1 = require("react");
const useWindowSize_1 = require("./useWindowSize");
function useIsMobile() {
    const { width: pageWidth } = (0, useWindowSize_1.useWindowSize)();
    return (0, react_1.useMemo)(() => pageWidth <= 530, [pageWidth]);
}
exports.useIsMobile = useIsMobile;
//# sourceMappingURL=useIsMobile.js.map